module.exports = __webpack_public_path__ + "static/media/delete-outline-icon.f5365384.svg";